import { YieldQueries } from '@/features/assets/queries'
import { type MaybeRefOrGetter, toValue } from 'vue'
import { useMutationWithInvalidation } from '@/shared/composables/useMutationWithInvalidation'
import { updateYield } from '@/features/assets/api/updateYield'
import { YieldAction, YieldFileType } from '@/features/assets/constants'
import { removeYieldFile } from '@/features/assets/api/removeYieldFile'
import { attachYieldFile } from '@/features/assets/api/attachYieldFile'
import { actionYield } from '@/features/assets/api/actionYield'
import type { YieldUpdate } from '@/features/assets/types'

export const useYieldUpdate = (assetCode: MaybeRefOrGetter<string>) => useMutationWithInvalidation(
  (data: YieldUpdate) => updateYield(toValue(assetCode), data),
  [
    YieldQueries.fetch(assetCode).queryKey,
    YieldQueries.activityLog(assetCode).queryKey,
  ]
)

export const useYieldFileRemoval = (assetCode: MaybeRefOrGetter<string>) => useMutationWithInvalidation(
  (fileType: YieldFileType) => removeYieldFile(toValue(assetCode), fileType),
  [
    YieldQueries.fetch(assetCode).queryKey,
    YieldQueries.activityLog(assetCode).queryKey,
  ]
)

export const useYieldFileAttachment = (assetCode: MaybeRefOrGetter<string>) => useMutationWithInvalidation(
  (x: { fileType: YieldFileType, uploadId: string }) => attachYieldFile(toValue(assetCode), x),
  [
    YieldQueries.fetch(assetCode).queryKey,
    YieldQueries.activityLog(assetCode).queryKey,
  ]
)

export const useYieldAction = (assetCode: MaybeRefOrGetter<string>) => useMutationWithInvalidation(
  (action: YieldAction) => actionYield(toValue(assetCode), action),
  [
    YieldQueries.fetch(assetCode).queryKey,
    YieldQueries.activityLog(assetCode).queryKey,
  ]
)
